import React from 'react';
import PropTypes from 'prop-types';

import { T } from '../constants/tokens';

/**
 * The v7 page header: a 48px display title, an optional sub-line, and room on
 * the right for controls that belong to the page rather than the shell.
 *
 * Every screen opens with one of these, which is what makes the app read as a
 * single product rather than a set of pages.
 */
export default function PageHeader({ title, subtitle, actions = null, style = {} }) {
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-end',
        gap: 16,
        marginBottom: 32,
        ...style
      }}
    >
      <div style={{ flex: '1 1 300px', minWidth: 0 }}>
        <h1
          style={{
            margin: 0,
            fontSize: 48,
            fontWeight: 600,
            lineHeight: '48px',
            letterSpacing: '-2.4px',
            color: T.ink,
            textWrap: 'pretty'
          }}
        >
          {title}
        </h1>
        {subtitle &&
          <p style={{ margin: '8px 0 0', fontSize: 16, lineHeight: '24px', color: T.body }}>
            {subtitle}
          </p>}
      </div>
      {actions &&
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8 }}>
          {actions}
        </div>}
    </div>
  );
}

PageHeader.propTypes = {
  title: PropTypes.node.isRequired,
  subtitle: PropTypes.node,
  actions: PropTypes.node,
  style: PropTypes.object
};
